
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'
import useGaspAnimations from '../components/useGsapAnimations'

const clients = [

{
    title:`PROCESS / PHARMACEUTICAL INDUSTRY`,
contents:[


    {
    name:`M/s: Ramagundam Fertilizers and Chemicals Limited, Fertilizer City, Fertilizer`,
product:`Corporation Of India, Godavarikhani, Ramagundam, Telangana 505210.
Supply of Reciprocating compressor package with 2No’s MYCOM Reciprocating
compressor for R407C industrial water chiller (Explosion Proof Applications) @ (-) 5°C SST
and (+) 38°C SDT. MYCOM Reciprocating compressor model N2K x 2no’s.`

},
{
name:`M/s: Greenstar Fertilizers Limited (SPIC), Tuticorin.`,
product:`Supply of Screw Package with 1no’s Bitzer screw compressor for ammonia boil-off
compressor for ammonia storage at Tuticorin port terminal (Explosion Proof
Applications) @ (-) 40°C SST and (+) 38°C SDT compressor Model OSNA8571-K x
1no’s.`

},
{
name:`M/s. Atofina Peroxides India ltd, Cuddalore.`,
product:`Supply of refrigeration controls and valves for (-) 35°C brine chilling plant.`

},
{
name:`M/s. Orchid Chemicals and Pharmaceuticals ltd., Chennai.`,
product:`Assembling, pressure testing and commissioning of cascade refrigeration system
(21 TR) with HOWDEN screw compressors for (-) 65°C brine chilling plant. Supply of
evaporative condenser and Automatic oil rectifies system for (-) 65°C brine chilling plant.`   
} 
]
},
{
title:`FOOD PROCESSING INDUSTRY`,
contents:[

    {
    name:`M/s: Asvini Fisheries, Bhimavaram.`,
product:`Supply of Refpak System with 1no’s York Screw Compressor Block for capacity of 920kg/hr
JBT IQF Freezer @ (-) 40°C SST and (+) 38°C SDT. Compressor model RWFII134E x
1no’s.`

},
{
name:`M/s: Asvini Fisheries, Tuticorin.`,
product:`Supply of Refpak System with 1no’s York Screw Compressor Block for capacity of 550kg/hr
JBT IQF Freezer @ (-) 40°C SST and (+) 38°C SDT. Compressor model RWFII101E x
1no’s.`

},
{
name:`M/s: VV Marine, Tuticorin.`,
product:`Supply of Refpak System with 1no’s York Screw Compressor Block for capacity of 550kg/hr
JBT IQF Freezer @ (-) 40°C SST and (+) 38°C SDT. Compressor model RWFII101E x
1no’s.`

},
{
name:`M/s: BMR Exports, Nellore.`,
product:`Supply of Refpak System with 3No’s Mycom Screw Compressor Block for capacity of
750kg/hr Arico IQF Freezer @ (-) 40°C SST and (+) 38°C SDT, compressor model i160L-M
x 3no’s.`

},
{
name:`M/s: BMR Exports, Nellore.`,
product:`Supply of Refpak System with 2No’s Mycom Compressor Block for capacity of 50TPD Plate
Ice Machine @ (-) 10°C SST and (+) 38°C SDT Compressor Model N8L x 1no’s.`

},
{
name:`M/s: Kan Foods, Gujarat.`,
product:`State of the art Refrigeration packages with Bitzer screw compressors for Blast Freezer,
IQF Freezer, Plate Freezer, Water Chiller,Tube Ice Machine with Complete Ref Pack
System with 4no’s BITZER Screw compressor (OSNA8571-K X 4No’s).`

},
{
name:`M/s. Jayavani Ice Unit Pvt .Ltd, No.25, Kumbalamman Koil Street, Tondiarpet,`,
product:`Chennai
Supply of Screw Package with 1no’s BITZER SCREW compressor for Capacity of 45
ton per day Block Ice plant @ (-)15°C SST and (+) 40°C SDT, compressor model
OSKA8591-K x 1no’s.`

},
{
name:`M/s: Asvini Fisheries, Bhimavaram.`,
product:`Supply of Screw Package with 1no’s BITZER SCREW compressor for capacity of 750kg
Plate Freezer @ (-) 40°C SST and (+) 38°C SDT, compressor model
OSNA8571-K x 1no’s.`


},
{
name:`M/S. Theva & CO, Tuticorin`,
product:`Supply of Screw Package with 1no’s BITZER SCREW compressor for 750Kg freezing in
90Min Plate freezer @ (-) 40°C SST and (+) 38°C SDT, compressor model OSNA8571-K x
1no’s.`

},
{
name:`M/S: Tamil Nadu Food grains Marketing Yard, Alanganallur Road, Sikkandarchavadi,`,
product:`Madurai – 625 018. Tamil Nadu.
Supply of Screw Package with 2no’s BITZER SCREW compressor for Capacity of 5000MT
cold storage @ (-) 5°C SST and (+) 40°C SDT. Application - cold room for positive temp.
Compressor model OSKA5361-K x 1no’s.`

},
{
name:`M/S: Shree Rama Cold Storage Ltd, 5-18, Durga Nagar, Dilsukhnagar, 500060 -`,
product:`Hyderabad
Supply of Screw Package with 2no’s BITZER SCREW compressor for Capacity of 5000MT
cold storage @ (-) 5°C SST and (+) 40°C SDT. Application - cold room for positive temp.
Compressor model OSKA7471-K x 1no’s.`

},
{
name:`M/S: Western Farmfresh Pvt Ltd, #37 Varadharajapuram, Poonamallee, Chennai.`,
product:`Supply of Screw Package with 1no’s BITZER SCREW compressor for 450Kg freezing in
90Min spiral freezer @ (-) 40°C SST and (+) 38°C SDT Compressor model OSNA8571-K
x 1no’s.`

},
{
name:`M/S: Baby Marine Products, Harbour View, Malpe, Udupi – 576108. Karnataka.`,
product:`Supply of Screw Package with 4no’s BITZER Booster SCREW compressor (OSKA8571-K
X 4No’s) and 2no’s High Stage Screw compressor (OSKA8581-K) for 2 no’s Blast Freezer
each having Capacity of 2ton, 1 no’s plate freezer having capacity of 1000 Kg every 90
Minutes and plate ice 25TPD per day @ (-) 45°C SST.`

},
{
name:`M/S: VR Foods Enterprises, Poonamallee, Chennai.`,
product:`Supply of Screw Package with 1no’s BITZER SCREW compressor for 1ton Blast
Freezer within 2hrs @ (-) 40°C SST and (+) 38°C SDT. Compressor model
OSNA8571-K x 1no’s.`

},
{
name:`M/S. Theva & CO, Tuticorin`,
product:`Modification of existing gravity feed Refrigeration Plant with Pump Circulation
refrigeration system for increasing the efficiency of the plant.`

},
{
name:`M/S. Nila SeaFoods, Tuticorin`,
product:`Supply, erection and commissioning of LP receiver and Intercoler.`

},
{
name:`M/S. Edhayam Frozen Foods, Tuticorin`,
product:`Modification of existing gravity feed Refrigeration Plant with Pump Circulation refrigeration
system for increasing the efficiency of the plant.`


},
{
name:`M/S. Kadal Kanny Frozen Foods, Tuticorin`,
product:`Modification of existing gravity feed Refrigeration Plant with Pump refrigeration
system Circulation for increasing the efficiency of the plant.`

},
{
name:`M/s. Amrut Cold Storages Pvt Ltd, Veraval.`,
product:`Supply, erection and commissioning of 500 Kgs/Hr IQF Freezer, Glazer and Glaze
Hardener and Supply, erection and commissioning of (-) 40°C pump vessel,(-) 10°C
Intercooler, Design and Engineering of complete refrigeration plant with Hot Gas Defrosting
Arrangement.`

},
{
name:`M/s. Sri Siddhi Freezers and Exporters Pvt Ltd, Manglore.`,
product:`Supply, erection and commissioning of 2.40 MT /2.5 Hrs TROLLEY Freezer,
Design and Engineering of complete Refrigeration Plant.Supply and Erection of
Indus make Evaporative Condensers.`

},
{
name:`M/s. Sagar Grandhi Exports Pvt Ltd, Singarayakonda.`,
product:`Supply, erection and commissioning of 500 Kgs/Hr IQF Freezer, Glazer and Glaze
Hardener and Supply, erection and commissioning of (-) 40°C pump vessel,(-) 10°C
Intercooler, Design and Engineering of complete refrigeration plant with Hot gas defrosting
arrangement.`

},
{
name:`M/s. Sumaraj Sea Foods Pvt Ltd, Mumbai.`,
product:`Supply, erection and commissioning of 500 Kgs/Hr IQF Freezer, Glazer and Glaze
hardener and Supply, erection and commissioning of PLC Control panel for complete
refrigeration plant. Design and Engineering of complete refrigeration plant with Hot gas
defrosting arrangement. Supply and Erection of Indus make evaporative condensers.`

},
{
name:`M/s. Asvini Fisheries Pvt Ltd, Bhimavaram.`,
product:`Supply, erection and commissioning of 500 Kgs/Hr IQF Freezer, Glazer and Glaze
hardener and Supply, erection and commissioning of (-) 40°C pump vessel, (-) 10°C
Intercooler, Design and Engineering of complete refrigeration plant with Hot gas defrosting
arrangement and Supply & erection of Indus make Evaporative Condenser.`

},
{
name:`M/s. CP Aqua Culture (I) Ltd., Chennai.`,
product:`Repairing and Refurbishing of (-) 40° C Pump recirculation refrigeration system with screw
compressors.`

},
{
name:`M/s. Apex Exports, Kakinada.`,
product:`Supply, erection and commissioning of freezing and refrigeration equipments for
maintaining (-) 25° C in cold stores (2 nos), plate freezers (3 Nos) which can freeze the
product at (-) 40° C, IQF freezers which can freeze the product at (-) 40° C, chill room
where the product will be chilled at (+) 2° C, flake ice machines which can produce flake ice
10 & 15 MT per day, Block ice plant for producing 20 MT of block ice per day and 3000 LPH
water chilling plant to supply chilled water at (+) 2° C using PHE chiller. The above
refrigeration plant uses pump recirculation system for all the equipments except for ice
plant.`


},
{
name:`M/s. Blue Park Sea Food Pvt. Limited, Pamarru.`,
product:`Supply, erection and commissioning of 500 Kgs/Hr IQF Freezer, Glazer and Glaze
hardener Supply, erection and commissioning PLC Control panel for complete refrigeration
plant. Design and Engineering of complete refrigeration plant with Hot gas defrosting
arrangement.`

},
{
name:`M/s. RVR Marine Food Products, Bhimavaram.`,
product:`Supply, erection and commissioning of 500 Kgs/Hr. IQF Freezer, Glazer and Glaze
hardener Supply, erection and commissioning PLC Control panel for complete refrigeration
plant. Design and Engineering of complete refrigeration plant with Hot gas defrosting
arrangement.`

},
{
name:`M/s. Surya Udyog Limited, Bhubaneshwar.`,
product:`Supply, erection and commissioning of 500 Kgs/Hr IQF Freezer, Glazer and Glaze
hardener and PLC Control panel for complete refrigeration plant.Design and Engineering of
complete refrigeration plant with Hot gas defrosting arrangement. Supply, Erection and
Commissioning of 1 No. 350 KW stainless steel Evaporative Condenser.`

},
{
name:`M/s. Vijaya Durga Ice Industries, Kaikalaru.`,
product:`Supply, Erection and Commissioning of 1 No. 850 KW Stainless steel Evaporative
Condenser.`

},
{
name:`M/s. Suvarna Rekha Exports Pvt. Ltd, Vishakapatnam.`,
product:`Design, Engineering, consultancy, Modification of Blast freezer and Erection of machinery
for Seafood processing plant & AMC for the same.`

},
{
name:`M/s. Five Star Marine Exports Pvt. Ltd, Nellore.`,
product:`Supply of Evaporative condenser and electrical switchboard.
Supply, erection and commissioning of 250 Kgs/Hr IQF Freezer,
Design and Engineering of complete refrigeration plant.`

},
{
name:`M/s. Devi Sea Foods Ltd, Vishakapatnam.`,
product:`(–) 400
C Centralized, automatic Pump circulation refrigeration systems with PLC switch
board. The system is taking care of Plate freezers, IQF freezers, Blast freezers, and Flake
ice units, cold rooms with hot gas defrosting, water chillers and chill room.`

},
{
name:`M/s. Anjaneya Sea Foods Ltd., Nellore.`,
product:`Supply of Refrigeration Valves, Controls, PUF Insulation for Refrigeration Lines and Cold
Room Insulation.`

},
{
name:`M/s. Sathya Sea Foods Ltd, Vishakapatnam.`,
product:`(–) 400
C Centralized, automatic Pump circulation Refrigeration System with PLC switch
board. The system is taking care of Plate freezers, IQF freezers, Blast freezers, Flake ice
units and cold rooms with hot gas defrosting.`


},
{
name:`M/s. Avanthi Feeds Ltd, Gopalapuram.`,
product:`Supply of skid mounted pump vessel, Baudelot chiller, Ammonia Air cooling units,
Automatic control panel and related refrigeration equipments. Erection and commissioning
of Flake ice unit and Refrigeration system for IQF freezer.`

},
{
name:`M/s. Devi Marine Food Exports Ltd, Chennai.`,
product:`Supply of Low-pressure vessel made out of SA 516 Grade 70 material, Control Panel for
Ammonia Pumps and Pressure regulating and control valves for Ammonia Refrigeration
plant operating at (–) 400C and automatic defrosting control system for existing cold rooms.`


},
{
name:`M/s. Capricon Food Products India Ltd., Sathyavedu.`,
product:`Design, Engineering and Commissioning of complete Refrigeration Plant with Hot Gas
defrosting system for Fruits & Vegetables Processing and freezing plant with 1 No. of IQF
Freezer (3.6MT/Hr-based on Green Peas) @ (-) 400C, 4 Nos. of Cold Stores with a capacity
of 2700 MT each, 2 Nos. of Blast Freezer, PHE Chiller with “STATE OF THE ART
TECHNOLOGY”.`

},
{
name:`M/s. Nekkanti Sea Foods Ltd., Vishakapatnam.`,
product:`Supply of spare parts for existing (–) 400C Pump recirculation Refrigeration Plant.`

},
{
name:`M/s. Karnataka Fisheries & Development Corporation, Mangalore.`,
product:`Supply & Erection of Evaporative Condenser with a warrantee of 5 years`

},
{
name:`M/s. Mangalore Trawl Boat Fishermen Primary Co-Op Society, Mangalore.`,
product:`Supply and Erection of Evaporative Condenser with a warrantee of 5 years.`

},
{
name:`M/s. Goan Bounty, Goa.`,
product:`Modification of existing Refrigeration Plant with Pump Circulation for increasing the
efficiency of the plant. Design consultancy and Engineering of complete refrigeration plant.
Supply of Blast Freezers with Refrigeration Plant.`

},
{
name:`M/s. Sai Kishan Fisheries Expansion, Udupi, Karnataka.`,
product:`Design, Supply and Erection Commissioning of Blast Freezers (30 MT Per Day Fish
Freezing Plant) with complete refrigeration plant. Supply of Refrigeration Valves, Controls,
PUF Insulation for Refrigeration Lines and Cold Room Insulation. Supply and Erection of
Danfoss Cold Room units operating at (-) 21 0 C.`

},
{
name:`M/s. Oceanic Edibles International Ltd., Marakkanam.`,
product:`Design & Engineering Erection and Commissioning of complete Refrigeration Plant with Hot
Gas defrosting system for Integrated Plant with MYCOM Screw Compressors for Fruits &
Vegetables and Sea-food Processing plant with 2 Nos. IQF Freezer(3.6MT/Hr-based on
Green Peas) @ (-) 400C, Glaze Hardener, 6 Nos. of Cold Stores with a capacity of 2700 MT
each, 5 Nos. of Blast Freezer, Plate Freezers, Flake Ice Machine, Tube Ice Machine, PHE
Chiller with “STATE OF THE ART TECHNOLOGY”. Fully automatic PLC controls with
SCADA programming for the complete plant. Supply of IQF machine, Blast Freezer Coils,
Coils for Cold Store, Ante Room, Glaze Hardener and Glazer for processing Marine
products.`


},
{
name:`M/s: Hindustan Ice & Cold Storage Limited, Kolkata.`,
product:`Supply and erection of (-) 40°C pump vessel, (-) 10°C Intercooler.`

},
{
name:`M/s. Sun Shine Packaging Industries, Bhubaneswar, Orissa.`,
product:`Design, Engineering, Supply, Erection and Commissioning of IQF Freezer, Glazer and
Glaze Hardener for Marine Products.`

},
{
name:`M/s. Hind Ice and Cold Store, Kolkata.`,
product:`Supply and erection of Blast Freezer and EPS panels.`

},
{
name:`M/s. Goan Fresh Marine Exports Pvt Ltd, Kota, Karnataka`,
product:`Design & Engineering Erection and Commissioning of complete Refrigeration
Plant with Hot Gas defrosting system for Integrated Plant with Kirloskar
compressors Sea-food Processing plant with 4 Nos of Blast Freezers, Cold
rooms, Anti room, packing room, chill room,Fully automatic PLC controls.`

},
{
name:`M/s.Allied Exim, Chennai`,
product:`Supply, erection and commissioning of 500 Kgs/Hr marine Glaze Hardener`

},
{
name:`M/s.Ulka Seafoods Pvt Ltd`,
product:`Supply and erection of 2 Nos of Blast Freezer and Refrigeration system. Modification of
existing Refrigeration Plant with Pump Circulation for increasing the efficiency of the plant.`

},
{
name:`M/s.Tolar Ocean Products Pvt Ltd, Kundapura`,
product:`Supply and erection of Blast Freezer and Refrigeration system. Modification of existing
Refrigeration Plant with Pump Circulation for increasing the efficiency of the plant. Supply
of 3 Nos of SS evaporative condensers.`

},
{
name:`M/s.Choice Trading Corporation, Kochin`,
product:`Supply and erection of Blast Freezer. Design consultancy and Engineering of complete
refrigeration plant.`

},
{
name:`M/s.Natural Frozen Dehydrated Foods, Gujarat`,
product:`Supply, erection and commissioning of 1200 Kgs/Hr Fruits & Vegetable IQF
Freezer.`

},
{
name:`M/s. Sagar Grandhi Exports Pvt Ltd, Kota`,
product:`Design & Engineering, supply of pressure vessels,Electrical Panels, Erection
and Commissioning of complete Refrigeration Plant with Hot Gas defrosting
system for Integrated Plant with MYCOM Screw Compressors for Sea-food
Processing plant.`

},
{
name:`M/S. Sun Aquatic Products Pvt Ltd, Kerala`,
product:`Supply of (-) 40"C LP Receiver for 1 no of lQF Freezer, (-) 40'C LP Receiverfor
1 no BF, 1 no PF, 1 no FIM (-) 5'C lntercooler for 900kw, System Receiver to
hold 2000 Kgs of Ammonia and Oil Pot.`


},
{
name:`M/S. Iceman Technologies Pvt Ltd.`,
product:`Supply, erection and commissioning of Ammonia Screw Compressor System
with Mycom Japan Make Ammonia Screw Compressor Package, Evaporative
condensers, (-) 40°C LP receiver package, (-) 37°C LP receiver package, (-)
10°C LP receiver package, HP Receiver, Valves & controls and Engineering,
field visit assistance and commissioning of the plant.`

},
{
name:`M/S. Protech Organo Foods Pvt Ltd, Kerala.`,
product:`Complete Turnkey Refrigeration System for 1000 Kg/Hr. IQF Line, 500
Kg/Hr. IQF Line, 1000 Kg per batch (60mins) Plate Freezers, 5400 Kg per
batch (5hrs)Blast Freezer (Ribbonfish in 6Hrs), 25MT Flake Ice Machine,
15MT Flake Ice Machine, 5,000 Lts / Hrs. Water Chiller with erection and
commissioning.`

},
{
name:`M/S. Abad Overseas Pvt. Ltd., Irungattukottai, Chennai`,
product:`Supply, erection and commissioning of Ammonia 2stage Reciprocating
Compressor Package with Mycom Japan Make 2stage Reciprocating
Compressor Block and (-) 5°C Open Flash Inter Cooler for N62MII and KC-72
Compressors.`

},
{
name:`M/s: BMR Industries Pvt Ltd, AP`,
product:`Supply, erection and commissioning of 2 nos. of Ocean blue evaporative
condenser model ECB – 450 for Ice Plant application.`

},
{
name:`M/S: Baby Marine (Eastern) Exports, AP.`,
product:`Supply, erection and commissioning of Ocean blue evaporative condenser
model ECB – 650 and ECB – 300 for Sea food application.`

},
{
name:`M/s. VV Marine, Tuticorin, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N62M.
Supply and Commissioning of 2 nos of Indus make Automatic 4-point Pump feed (flooded)
Air purger.`

},
{
name:`M/S. BMR Exports, Pondicherry`,
product:`Supply, erection and commissioning of HEAT PUMP FOR POND HEATING
which includes Ammonia compressor, Condenser, Receiver, Air cooling coil,
5000 Lts Balancing Tank with insulation, Water Circulation Pump, Titanium
Heating Coils for Ponds with PLC Automation
M/S .BMR Industries Private Limited, Nellore
Supply of Ammonia HP Receiver package and Suitable Level Ammonia Level
Glass for the HP Receiver.`


},
{
name:`M/S: Baby Marine (Eastern) Exports, Tuticorin`,
product:`Supply, erection and commissioning of Air Cooled Ammonia NH3 Refpak
refrigeration system for 3No’s (1200 x 1Nos + 400 x 2Nos) Frozen Cold
Storage, 2No’s Anti Room and 1No’s Packaging Room.`

},
{
name:`M/S: Satish Marine Exim Pvt Ltd, Bapatla, AP`,
product:`Supply and commissioning of (-) 45°C LP receiver with Oil port for IQF,(-)45°C
LP receiver with Oil port for PF and FIM, (-) 5°C Intercooler, HP Receiver,
MCC control panel, PLC Automation system for the total plant.`

},
{
name:`M/S: Satish Marine Exim Pvt Ltd, Bapatla, AP`,
product:`Supply and commissioning of Booster Mycom Reciprocating compressor
package model N6M for IQF freezer, Single stage Mycom Reciprocating
compressor package model N62M for PF freezer, Single stage Mycom
Reciprocating compressor package model N62M for FIM, Single stage Mycom
Reciprocating compressor package model N8L for IQF High stage and water
chiller for IQF chiller.`

},
{
name:`M/S: Satish Marine Exim Pvt Ltd, Bapatla, AP`,
product:`Supply and commissioning of 3 nos of Mycom Reciprocating compressor
package (2 booster and 1 high stage) for IQF freezer. Compressor model
Mycom N8L.`


},
{
name:`M/S: Devi sea foods Pvt Ltd,Singarayakonda, AP`,
product:`Supply, erection and commissioning of Mycom ‘i’ series Ammonia screw
compressor package with PLC Automation.`

},
{
name:`M/s.Varma Marine,West Godavari, AP`,
product:`Complete Turnkey Limited Charge Refrigeration System for 920 Kg/Hr. Raw
(Shrimp) IQF Line With Glaze Hardener, 750 Kgs Plate Freezer, 30 TPD Flake
Ice Machine, 40 TPD Tube Ice Machine, 3000 Lts / Hrs. Water Chiller, 8000
Lts / Hrs. Water Chiller, Frozen Cold Room, Ante Room, Chill Room, Offal
Room, Receiving Area Air Conditioning, Pre-Processing Area Air Conditioning,
Processing Area Air Conditioning IQF, Packing Area Air Conditioning INDUS
REFPAK using York (USA), JCI make screw compressors with erection and
commissioning.`

},
{
name:`M/s. Aparna Marine, Bapatla, AP`,
product:`Supply of low charge ammonia refrigeration system for IQF, GH with Indus
RefPak and low charge ammonia refrigeration system for Plate freezer and
Flake ice machine and water chiller and low charge ammonia refrigeration
system for 3 no cold storage, Ante room, Chill Room, Pre Processing and
Processing area Air conditioning, Evaporative condensers, Plate Freezers with
complete design and Engineering services.`


},
{
name:`M/s. Aparna Marine, Bapatla`,
product:`Supply, erection and commissioning of 800 Kg/hr Raw IQF line based on raw
HLTO shrimps.`

},
{
name:`M/s. Sai Kishan Fisheries Expansion, Udupi, Karnataka.`,
product:`Design, Erection supervision, Commissioning (refurbishing) of old plant with
Blast Freezers and Plate freezers (30 MT Per Day Fish Freezing Plant).
Supply of HP receiver and (-)40 LP horizontal re-circulator package.`

},
{
name:`M/s. Asvini Fisheries Pvt Ltd, Tuticorin.`,
product:`Supply, erection supervision and commissioning of (-) 40°C pump vessel, (-) 10°C
Intercooler for new Flake ice machines.`

},
{
name:`M/s. Ocean Fresh Exports Pvt Ltd, Udupi, Karnataka.`,
product:`Supply and Commissioning of Indus make Automatic 4-point Pump feed (flooded) Air
purger.`

},
{
name:`M/s. Suguna Foods Pvt Ltd, Udumalpet, Tamilnadu.`,
product:`Energy Audit of the existing refrigeration plant.`

},
{
name:`M/s. Royal Imports and Exports, Andhra Pradesh.`,
product:`AMC service for Ammonia refrigeration plant.`

},
{
name:`M/s. AL Salem Air Conditioning Co (Arasco), Jeddah, Saudi Arabia.`,
product:`Supply of HP receiver, Low pressure vessel, Low pressure Intercooler, Oil pot, Automatic
gas purger and Sight glass assembly.`

},
{
name:`M/s. AL Salem Air Conditioning Co (AL Zamil), Jeddah, Saudi Arabia.`,
product:`Supply of HP receiver, Vertical Economisze and Gas purger.`

},
{
name:`M/s. Goan Bounty, Goa.`,
product:`Supply, erection and commissioning of Air purger and erection work of Blast freezer,
condenser, cold storage coils and 15 kW Air cooling coils with Danfoss valve station.`

},
{
name:`M/s. AL Salem Air Conditioning Co (Nassaim), Jeddah, Saudi Arabia.`,
product:`Supply of HP receiver, Low pressure separator, Vertical Economizer and Oil pot.`

},
{
name:`M/s. AL Salem Air Conditioning Co (IFFCO), Jeddah, Saudi Arabia.`,
product:`Supply of HP receiver, Low pressure separator, Oil pot and Air purger.`
}
]
},
{
title:`DAIRY INDUSTRY`,
contents:[

    {
    name:`M/S: Hatsun Agro Products, Attur Main Road, Karipatti, Salem - 636106.`,
product:`Supply of Screw Package with 2no’s Kirloskar Reciprocating compressor model KC - 72 for
1ton per hr. spiral freezer for Ice Cream Bulk Pack @ (-) 40°C SST and 38°C SDT.`

},
{
name:`M/S: Hatsun Agro Products, Bandapalli Village, Putalapattu Mandal, Chittoor – 517`,
product:`124.
Supply of Chiller Package with 1no’s MYCOM SCREW compressor for Return water chiller
for IBT tank @ (-) 15°C SST and 38°C SDT.`

},
{
name:`M/S: Hatsun Agro Products, Kundhur Village, Honnali TK.`,
product:`Supply of Chiller Package with 1no’s MYCOM SCREW compressor for Return water chiller
for IBT tank @ (-) 15°C SST and 38°C SDT.`

},
{
name:`M/S: Hatsun Agro Products, Dharapuram Coimbatore.`,
product:`Supply, erection and commissioning of Ammonia refrigeration system for IBT System, Milk
cold room, Curd cold room and curd blast room of refrigeration capacity of 860 kW with
Mycom Screw compressor model i160 L-L.`

},
{
name:`M/s. Kanika Milk Centre, Dindigul, TN`,
product:`Supply and commissioning of MYCOM Reciprocating bare compressor model N8K.`

},
{
name:`M/S: Heritage foods India limited, Poonamallee, Chennai.`,
product:`Supply of Screw Package with 3no’s MYCOM SCREW compressor for 15ton Curd Chiller
Within 2hrs. Compressor Model OSKA7441-K x 1no’s.`

},
{
name:`M/S: Heritage foods India limited, Padmanabham, AP.`,
product:`Supply, erection and commissioning of Freon IBT with 3 nos Emerson Compressors with
control panel.`

},
{
name:`M/S: Heritage foods India limited, Pamaru, AP.`,
product:`Supply, erection and commissioning of Skid Mount Refrigeration Plant (Return Water PHE
chiller with U-turn Accumulator unit).`

},
{
name:`M/s: Heritage Foods India Limited, Tirupathi, AP.`,
product:`Supply of 5000 Lts Ammonia HP Receiver Package.`

},
{
name:`M/S: Heritage foods India limited, Bobbili, AP.`,
product:`Supply and commissioning of SCADA system for the existing refrigeration plant.`

},
{
name:`M/s. Heritage Foods Ltd, Punjab`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`

},
{
name:`M/s. Heritage Foods Ltd, Vishakapatnam, AP`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`


},
{
name:`M/s. Heritage Foods Ltd, Sonipat, Haryana`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`

},
{
name:`M/s. Heritage Foods Ltd, Sonipat, Haryana`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N6L.`

},
{
name:`M/s. Heritage Foods Ltd, Nalgonda`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N6L.`

},
{
name:`M/s. Heritage Foods Ltd, Solapur`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`

},
{
name:`M/s. Heritage Foods Ltd, Punjab`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`

},
{
name:`M/S. Creamline Dairy Products Ltd, Madanapalli.`,
product:`Supply and erection of 2000 Litres HP Receiver with Automatic Water sprinkler method and
10 % Radiography test cost with 100 % MPI for T- Joints & nozzle joints.`

},
{
name:`M/S. Creamline Dairy Products Ltd, Kalakada.`,
product:`Supply and erection of 590 Litres HP Receiver with Valves and controls.`

},
{
name:`M/S. Parag Milk Foods Ltd, Palamner.`,
product:`Supply and erection of 2500 Litres HP Receiver.`

},
{
name:`M/S. Kurnool Milk Producer Mutually Aided Co-op Union Ltd, Vijaya Dairy, Kurnool,`,
product:`AP.
Supply and Commissioning of 2 nos of N4L compressor packages for IBT system.`

},
{
name:`M/s. Heritage Foods Ltd, Bhattiprolu, Guntur, Andhra Pradesh`,
product:`Supply of 1500 Litres Ammonia HP receiver package.`
}
]
},
{
title:`BLOCK ICE PLANTS`,
contents:[

    {
    name:`M/s. PNR Ice Plant, Nagapattinam, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`

},
{
name:`M/s. Jeyavani Ice Unit, Chennai, TN`,
product:`Supply and commissioning of Freon MYCOM Reciprocating compressor package model
F4L.`

},
{
name:`M/s. Matha Ice Factory, Karaikal, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N6L.`

},
{
name:`M/s. Kumaran Ice Plant, Pondicherry, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4K.`

},
{
name:`M/s. Murugan Ice Factory, Karaikal, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`

},
{
name:`M/s. Sri Uthukattuamman Ice Company, Pondicherry, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`

},
{
name:`M/s. ICE MAN, Chennai, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N6L.`

},
{
name:`M/s. PSA Cold Storage, Sivagangai, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`

},
{
name:`M/s. Franklin Ice Plant, Kanyakumari, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N8L.`

},
{
name:`M/s. BJ Ice Plant and Cold Storage, Kanyakumari, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`

},
{
name:`M/s. ARS, Kanyakumari, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N6L.`

},
{
name:`M/s. SNR Ice Plant, Rameshwaram, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`

},
{
name:`M/s. LT Ice Plant, Kanyakumari, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`

},
{
name:`M/s. Sri Amman White Ice Plant, Pudukkottai, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`


},
{
name:`M/s. Muthuswamy Ice Company and Cold Storage, Ramanathapuram, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N6K.`

},
{
name:`M/s. MB Ice Plant, Nagercoil, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N6L.`

},
{
name:`M/s. Sri Amman Ice Plant, Pudukkottai, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4K.`

},
{
name:`M/s. PMS Ice Plant, Tirunelveli, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`

},
{
name:`M/S. Sri Sakthi Engineering Works, Tuticorin`,
product:`Supply of 1 no. of Ocean blue evaporative condenser model ECB – 650 for
DSN Ice in Kanyakumari.`

},
{
name:`M/S. Sri Sakthi Engineering Works, Tuticorin`,
product:`Supply of 1 no. of Ocean blue evaporative condenser model ECB – 850 for SK
Ice Plant in Kanyakumari.`

},
{
name:`M/S. Sri Sakthi Engineering Works, Tuticorin`,
product:`Supply of 1 no. of Ocean blue evaporative condenser model ECB – 650 for
Veronica Ice Plant in Kanyakumari.`

},
{
name:`M/S. Sri Sakthi Engineering Works, Tuticorin`,
product:`Supply of 1 no. of Ocean blue evaporative condenser model ECB – 650 for Maria Ice Plant
in Kanyakumari.`

},
{
name:`M/s. Balaji Ice Factory, West Godavari, AP`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N6L.`

},
{
name:`M/s. Franklin Ice Plant, Kanyakumari, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N8L.`

},
{
name:`M/s. Star Ice Plant, Tuticorin, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N8L.`

},
{
name:`M/s. Shankar Industries, West Godavari, AP`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N6L.`

},
{
name:`M/s. Muthusamy Ice Company, Ramanathapuram, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`


},
{
name:`M/s. TKP Ice Plant, Rameshwaram, TN`,
product:`Supply of MYCOM Reciprocating compressor package model N4L.`

},
{
name:`M/S. NFS Ice Industry, Nellore.`,
product:`Supply and commissioning of Single stage Mycom Screw compressor Package model i160L-M
for 60 TPD Block Ice plant.`

},
{
name:`M/S. City Freezers, Madurai.`,
product:`Supply and commissioning of Single stage Mycom Screw compressor Package model i125S-L
for Block Ice plant.`

},
{
name:`M/s. SMF & Co, Kottaipattinam, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N6K.`

},
{
name:`M/s. KVS Ice Plant, Manamelkudi, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N4L.`

},
{
name:`M/s. VRP Ice Plant, Kanyakumari, TN`,
product:`Supply and commissioning of MYCOM Reciprocating compressor package model N6L.`
},
]
}
]

function MarketPharma() {
     useGaspAnimations()
     
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    
     var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
       
      };
    return(
      <section id="smooth-wrapper">
          <Header/>
             <main>

                 <section className="breadcrumb-area">
                    <div className="container text-center">
                         <div className="sec-title">
            <h1 className="title-anim"><span>INDUS REFRIGERATION CLIENTS LISTS</span></h1>
        </div>
                    </div>
                </section>
                 <div class="specials-rebate-area">

                     
    <div class="container">
        {/* <div class="row">
            <div class="col-md-12 ">
                <div class="sec-title pull-left pd-bottom">
                    <h1><span>{item.title}</span></h1>
                </div>
               
            </div>
        </div> */}
        <div class="row">
            <div class="col-md-12 pd-bottom">
                <div class="table-responsive">
                    <table class="table special-offers-table">
                        <thead>
                            <tr>
                                <th>Industry Segment </th>
                                <th>Customer Name </th>
                                <th>Product</th>
                            </tr>
                        </thead>
                        {clients.map((item, i) => (
                        <tbody>
                            {item.contents.map((content, idx) => (
                            <tr>
                                <td class="single-offer-box">
                                    
                                    <div class="single-item">
                                        <span>{item.title}</span>
                                    </div>
                                </td>
                                <td class="single-offer-box">
                                    
                                    <div class="single-item">
                                        <span>{content.name}</span>
                                    </div>
                                </td>
                                <td class="single-offer-box">
                                    
                                    <div class="single-item">
                                        <span>{content.product}</span>
                                    </div>
                                </td>
                            </tr>
                            ))}
                            
                        </tbody>
                          ))}
                    </table>
                </div>
            </div>
        </div>
    </div>

</div>
             </main>
          <Footer/>
      </section>
    )
 }
 
 export default MarketPharma;


